import { get_GetHubById, get_ListHubs, patch_UpdateHub, post_CreateHub } from './generated/hubs.zod';
import type { hubsApi } from './generated/hubsApi';
import type { OpenApiResponseSchemas } from './validatingBaseQuery';

type HubEndpointName = keyof typeof hubsApi.endpoints;

export const hubsEndpointSchemas = {
    listHubs: get_ListHubs,
    getHubById: get_GetHubById,
    createHub: post_CreateHub,
    updateHub: patch_UpdateHub,
} as const satisfies Record<HubEndpointName, OpenApiResponseSchemas>;
